import { css } from '@emotion/react';
import { useNavigate } from 'react-router';
import { AvatarIcon, AvatarIcons, Col, colors, Row, Title, Button, Icon } from 'common-components';
import { Space } from 'antd';
import { CertificationType } from '@types';
import { formatPercent, localizeDate } from '@utils';
import { useAppTranslation } from '@hooks';

import PercentTag from './PercentTag';

type HeaderPropsType = {
  certification?: CertificationType
};

const Header = ({ certification }: HeaderPropsType) => {
  const navigate = useNavigate();
  const { translate } = useAppTranslation();
  const texts = [
    {
      type: 'tablePageTitle',
      content: certification?.name,
    },
    {
      type: 'tablePageSubtitle',
      content:
        certification?.creationDate &&
        translate('certification.passedOn', { date: localizeDate(certification.creationDate) }),
    },
  ];

  return (
    <div>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 16px 0;
        `}
      >
        <Col>
          <Row justify={'center'} gutter={16} align={'middle'}>
            <Col>
              <Button
                size="sm"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <Icon icon="ArrowNarrowLeft" size={20} />
              </Button>
            </Col>
            <Col>
              <AvatarIcon
                icon={certification?.icon?.iconName as AvatarIcons}
                style={{ backgroundColor: certification?.icon?.iconColor }}
                size={'xl'}
              />
            </Col>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space key={`title-${text.content}-${index}`} align={'center'}>
                      <Title style={{ fontSize: 18, lineHeight: '28px', color: colors.gray700 }}>
                        {text.content}
                      </Title>
                      {certification?.mark !== undefined && certification?.mark !== null && (
                        <PercentTag withIcon={false} state="positive">
                          {formatPercent(certification.mark)}
                        </PercentTag>
                      )}
                    </Space>
                  );
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                );
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
